/**
 * Created by neo on 01.01.17.
 */

import Config from '../Config/index'
import Backend from './Backend'

const Buffer = require('buffer/').Buffer

/**
 * Special class that does calls the backend by using the app credentials (client_credentials)
 */
class AppBackend {
  constructor () {
    this.authData = null
  }

  authorize () {
    if (this.authData === null) {
      // console.tron.log('trying to get authData');
      const backend = new Backend()
      const authKey = Buffer(`${Config.backend.clientId}:${Config.backend.clientSecret}`).toString('base64')
      const headers = {
        Authorization: `Basic ${authKey}`,
        Accept: 'application/json'
      }

      // TODO: backend authorization
      this.authData = {
        access_token: 'XXX'
      };

      return Promise.resolve(this.authData);

      const payload = {
        grant_type: 'client_credentials'
        // 'client_id': Config.backend.clientId,
        // 'scope': 'mobile',
      };

      // console.tron.log(headers);
      // console.tron.log(payload);
      return backend.postForm('/uaa/oauth/token', payload, headers).then(res => {
        // console.tron.log(res);
        if (res.ok) {
          this.authData = res.data
          return this.authData
        }
        throw Error('Invalid authentication')
      })
    }

    return Promise.resolve(this.authData)
  }

  post (path, data, headers = {}) {
    return this.authorize().then(authData => {
      // console.tron.log(authData);
      return new Backend(authData).post(path, data, headers)
    })
  }

  get (path, data, headers) {
    return this.authorize().then(authData => {
      return new Backend(authData).get(path, data, headers)
    })
  }
}

const instance = new AppBackend()
export default instance



// WEBPACK FOOTER //
// ./src/App/Services/AppBackend.js